import React, { useState, useEffect } from "react";
import Switch from "@mui/material/Switch";
import { Field } from "react-final-form";

export default function UiSwitch(props) {
     const { handleChange, checked, name, id } = props;

     const [isChecked, setIschecked] = useState(false);

     useEffect(() => {
          setIschecked(props.checked);
     }, [props.checked]);

     return (
          <Field
               name={props.name}
               defaultValue={isChecked}
               render={({ input, meta }) => {
                    return (
                         <>
                              <Switch
                                   {...props}
                                   {...input}
                                   checked={isChecked}
                                   onClick={(e) => {
                                        setIschecked(e.target.checked);
                                   }}
                                   inputProps={{ "aria-label": "controlled" }}
                              />
                         </>
                    );
               }}
          />
     );
}

export const UiSwitchList = (props) => {
     const [isChecked, setIschecked] = useState(false);

     useEffect(() => {
          setIschecked(props.checked);
     }, [props]);

     return (
          <>
               <Switch
                    {...props}
                    inputProps={{ "aria-label": "controlled" }}
                    checked={isChecked}
                    onClick={(e) => {
                         setIschecked(e.target.checked);
                         props.handleChange(e.target.checked);
                    }}
               />
          </>
     );
};
